import { CommonModule } from '@angular/common';
import { Component, Injector } from '@angular/core';
import { SuperDynamicComponent } from '../../../helpers/super-dynamic-component';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent extends SuperDynamicComponent {
  constructor(private injector: Injector) {
    super(injector);
  }
}
